export const siteInfo = {
  name: "131吃瓜",
  slogan: "最新梗都在这儿",
  domain: "https://gknov.cn",
  email: "hello@131chigua.example.com",
  intro:
    "131吃瓜是一个聚集网络热梗的简中内容站点。我们把散落在各个角落的梗图、表情包、神评论和网友二创收拢到一处，让你进来逛一圈，聊天里的梗能接住，配图也能顺手存走。",
  foundedYear: "2021",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "梗图", path: "/category/gengtu" },
  { label: "表情包", path: "/category/biaoqingbao" },
  { label: "神评论", path: "/category/shenping" },
  { label: "网友二创", path: "/category/erchuang" },
  { label: "热梗榜", path: "/rank" },
  { label: "关于我们", path: "/about" },
];

export const siteStats = [
  { label: "在库梗图", value: "12,600+" },
  { label: "表情包套组", value: "3,480+" },
  { label: "网友二创投稿", value: "860+" },
  { label: "每日更新条目", value: "120+" },
];

export const siteFaqs = [
  {
    q: "131吃瓜里的梗图和表情包可以自己存下来用吗？",
    a: "可以。站内的梗图和表情包都支持直接保存到本地，用于日常聊天、朋友之间斗图完全没问题。若是商业用途，请先通过联系页面与我们沟通授权事宜。",
  },
  {
    q: "多久更新一次？最新的梗什么时候能看到？",
    a: "我们每天至少更新一轮，热门梗通常会在出现后的一到两天内收录进站。首页的「今日最新」区块会优先展示刚整理好的内容，热梗榜每周刷新一次排序。",
  },
  {
    q: "我想投稿自己做的二创或者发现的梗，怎么提交？",
    a: "欢迎投稿。你可以通过联系我们页面留下的邮箱发送作品或链接，附上简短的来源说明即可。我们会筛选后收录进「网友二创」分类，并标注投稿作者。",
  },
  {
    q: "站内的「神评论」是怎么选出来的？",
    a: "神评论主要来自网友在评论区的精彩发言，我们从语言节奏、意外感和共鸣度几个角度人工筛选。入选的评论会保留原意，仅做少量标点整理。",
  },
  {
    q: "为什么有的梗我搜不到？",
    a: "部分梗存在多种叫法，你可以尝试换一个关键词，或直接到「梗合集」分类里按主题浏览。如果确实找不到，也欢迎告诉我们，我们会尽快补充。",
  },
  {
    q: "在手机上浏览体验怎么样？",
    a: "站点采用响应式设计，手机、平板和电脑都能正常浏览。手机端导航收进右上角菜单，图片会按屏幕宽度自适应，长按即可保存。",
  },
];

export const testimonials = [
  {
    name: "阿栗",
    role: "天天泡在群里斗图的打工人",
    text: "以前找图要翻好几个群，现在直接来这儿刷一圈就够了，神评论那栏经常把我笑到岔气。",
  },
  {
    name: "小满不加班",
    role: "设计专业在读",
    text: "二创区质量比我想的高，能看到作者的思路，比单纯存图有意思多了，偶尔还会顺手临摹一张。",
  },
  {
    name: "老周同学",
    role: "程序员",
    text: "分类做得很清楚，「打工人」这一挂的梗一套一套的，开会前刷两分钟，气就顺了。",
  },
  {
    name: "瓜田里的小李",
    role: "资深吃瓜群众",
    text: "更新速度是真的快，昨天刚冒出来的梗今天就能在榜上看到，配图也都顺手存好了。",
  },
];

export const aboutImage = {
  src: "https://readdy.ai/api/search-image?query=a%20small%20friendly%20content%20team%20sorting%20funny%20picture%20cards%20on%20a%20long%20desk%20with%20sticky%20notes%20and%20plant%20pots%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=1200&height=800&seq=about-team-01&orientation=landscape",
  alt: "内容团队在长桌前整理梗图素材的卡通插画",
};

export const contentPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "来源可追溯",
    text: "每条内容都会记录收录日期与来源说明，二创作品尽量保留原作者信息，方便你了解它从哪里来。",
  },
  {
    icon: "ri-emotion-normal-line",
    title: "表达不过火",
    text: "我们偏好好笑但不伤人的梗。涉及具体个人的内容会谨慎处理，避免把玩笑变成冒犯。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "更新不等风",
    text: "热门梗通常在一到两天内收录完成，首页的今日最新区块每天至少刷新一轮。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "分类要清楚",
    text: "每张图都会标好分类、标签和适用场景，让你需要的时候能快速找到，而不是翻半天。",
  },
];

export const contactChannels = [
  {
    icon: "ri-mail-line",
    label: "合作与投稿邮箱",
    value: "hello@131chigua.example.com",
    note: "适合二创投稿、内容合作与授权咨询，我们会在两个工作日内回复。",
  },
  {
    icon: "ri-feedback-line",
    label: "内容纠错",
    value: "fix@131chigua.example.com",
    note: "发现分类标错、来源有误或图片不适合展示，欢迎随时指出。",
  },
  {
    icon: "ri-time-line",
    label: "回复时间",
    value: "工作日 10:00 - 19:00",
    note: "节假日期间回复会稍慢一些，感谢你的耐心。",
  },
];